import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["color", "extraClass", "name", "size"];
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module '@datacamp/waffles-core/lib/ico... Remove this comment to see the full error message
import svgSprite from '@datacamp/waffles-core/lib/icons/symbols.svg';
import cx from 'classnames';
import React from 'react';
import { getColorClass } from '../core/colors';
import { jsx as ___EmotionJSX } from "@emotion/react";
/**
 *  @deprecated in favour of directly using icons from waffles
 */
const Icon = _ref => {
  let {
      color = null,
      extraClass = '',
      name,
      size = 18
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return ___EmotionJSX("svg", _extends({}, rest, {
    "aria-label": "".concat(name, " icon"),
    className: cx("dc-icon-".concat(name), getColorClass(color), extraClass),
    fill: "currentColor",
    height: size,
    key: name,
    role: "Img",
    width: size
  }), ___EmotionJSX("use", {
    xlinkHref: "".concat(svgSprite, "#").concat(name)
  }));
};
export default Icon;